const StorySection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">À propos</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="prose prose-lg text-gray-600 space-y-6">
            <p className="text-lg leading-relaxed">
              <strong className="text-blue-600">GLOBAL GRACE ENGINEERING</strong> est une société basée en République Démocratique du Congo, fournissant à ses clients des prestations de premier ordre dans les deux secteurs clés que sont le bâtiment et l'entretien.
            </p>
            
            <p className="text-lg leading-relaxed">
              Notre longévité et la qualité exceptionnelle de nos prestations, maintes fois démontrées et qui surpassent la concurrence, nous positionnent comme des collaborateurs de choix pour notre clientèle.
            </p>
            
            <p className="text-lg leading-relaxed">
              Cela est rendu possible par notre principe directeur : <strong className="text-blue-600">Bâtir avec excellence, restaurer avec grâce.</strong>
            </p>
            
            <p className="text-lg leading-relaxed">
              Global Grace Engineering se distingue comme une entité flexible et proactive, experte à la fois dans les projets de construction neufs et les opérations de maintenance.
            </p>
            
            <p className="text-lg leading-relaxed">
              Notre fierté réside dans notre quête inébranlable de l'excellence, notre savoir-faire technique pointu et une méthode de travail sur mesure centrée sur le client.
            </p>
            
            <p className="text-lg leading-relaxed">
              Forts d'un ancrage solide dans le secteur, nous proposons des réponses globales et ingénieuses, conçues pour satisfaire l'ensemble des exigences de notre clientèle.
            </p>
          </div>

          <div className="relative w-full h-full">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20construction%20engineering%20team%20working%20on%20modern%20building%20project%20in%20Democratic%20Republic%20of%20Congo%2C%20African%20construction%20workers%20with%20hard%20hats%20and%20safety%20equipment%2C%20construction%20site%20with%20cranes%20and%20steel%20framework%2C%20blue%20sky%20background%2C%20high%20quality%20professional%20photography%2C%20realistic%20detailed%20scene%20showing%20excellence%20in%20construction%20and%20maintenance%20work&width=800&height=900&seq=story-image-1&orientation=portrait"
              alt="Global Grace Engineering - Construction et Maintenance"
              className="rounded-xl shadow-lg object-cover object-top w-full h-[600px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
